import { render, staticRenderFns } from "./MailPersistenceEventList.vue?vue&type=template&id=40c9eea5&scoped=true&"
import script from "./MailPersistenceEventList.vue?vue&type=script&lang=js&"
export * from "./MailPersistenceEventList.vue?vue&type=script&lang=js&"
import style0 from "./MailPersistenceEventList.vue?vue&type=style&index=0&id=40c9eea5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c9eea5",
  null
  
)

export default component.exports